const requestsMap = {};

function urlExists(url) {
  if (typeof requestsMap[url] === 'boolean') {
    return requestsMap[url];
  }

  const http = new XMLHttpRequest();
  http.open('HEAD', url, false);
  try {
    http.send();
  } catch (error) {
    console.log(error);
    return true;
  }
  if (http.status !== 404) {
    requestsMap[url] = true;
    return true;
  }
  requestsMap[url] = false;
  return false;
}

export { urlExists };
export default urlExists;
